import Vue from "vue";
import "@/config/icons";
import axios from "axios";
import App from "./App.vue";
import router from "./router";
import "./assets/css/tailwind.css";

if (process.env.VUE_APP_API_URL) {
	axios.defaults.baseURL = process.env.VUE_APP_API_URL;
}

axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

Vue.config.productionTip = false;

Vue.prototype.$http = axios;

new Vue({
	router,
	render: h => h(App)
}).$mount("#app");
